/**
 * Gets the display name of the user.
 *
 * @param user The User or SearchUser object.
 * @param fallback The fallback display name.
 */
export function getUserDisplayName(user, fallback = 'Unknown') {
    var _a, _b;
    const { anonymized_at, email, phone_number } = user;
    const contactOptions = [email, phone_number].filter(Boolean);
    const name = 'name' in user ? getUserName(user) : user.display_name;
    return ((_b = (_a = name !== null && name !== void 0 ? name : contactOptions[0]) !== null && _a !== void 0 ? _a : (anonymized_at ? 'Anonymized user' : undefined)) !== null && _b !== void 0 ? _b : fallback);
}
function getUserName(user) {
    var _a;
    const { family_name, given_name, name } = user;
    const fullName = given_name && family_name ? `${given_name} ${family_name}` : undefined;
    return (_a = name !== null && name !== void 0 ? name : fullName) !== null && _a !== void 0 ? _a : given_name;
}
